import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { LicensePlateState } from "./licensePlateTypes";

type IValidationObject = {
  licensePlateNumber: Yup.StringSchema<string>;
};

export enum ValidationType {
  CUSTOM_LICENSE_PLATE = "^[0-9a-zA-ZæøåÆØÅ]{1,2}\\s?[0-9a-zA-ZæøåÆØÅ ]{1,5}$",
  SHORT_LICENSE_PLATE = "^(UREG|[a-zA-Z]{2}\\s?[0-9]{4})$",
  DEFAULT_LICENSE_PLATE = "^[a-zA-Z]{2}\\s?[0-9]{5}$",
}

const getRegNumberFormatText = (validationType: ValidationType): string => {
  const { getText } = TextManager;

  switch (validationType) {
    case ValidationType.SHORT_LICENSE_PLATE:
      return getText("carform.validation.regnumberformat_short");
    case ValidationType.CUSTOM_LICENSE_PLATE:
      return getText("carform.validation.regnumberformat_custom");
    default:
      return getText("carform.validation.regnumberformat_default");
  }
};

export const licensePlateSchema = (
  validationType = ValidationType.DEFAULT_LICENSE_PLATE,
): Yup.StringSchema<string> => {
  const { getText } = TextManager;

  return Yup.string()
    .matches(new RegExp(validationType), getRegNumberFormatText(validationType))
    .nullable()
    .required(getText("carform.validation.regnumber_required"));
};

export const validationObject = (
  validationType = ValidationType.DEFAULT_LICENSE_PLATE,
): IValidationObject => ({
  licensePlateNumber: licensePlateSchema(validationType),
});

export const validationSchema =
  (validationType = ValidationType.DEFAULT_LICENSE_PLATE) =>
  (): Yup.ObjectSchema<LicensePlateState> => {
    return Yup.object(validationObject(validationType)).defined();
  };
